import "./DemoAccountIndicatorComponent.scss";
import {PortfolioSummary, PortfolioType} from "../../../portfolio/models/Portfolio";
import {IOnChanges, IOnChangesObject, IRootElementService} from "angular";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const DemoAccountIndicator = "demoAccountIndicator";

const template = `
    <span ng-if="ctrl.portfolio.portfolioType == 'SIMULATED'" class="badge demo-account-indicator"><span translate="common.SIMULATED"></span></span>
    <span ng-if="ctrl.portfolio.portfolioType == 'LINKED'" class="badge demo-account-indicator">LINKED</span>
`;

export function demoAccountIndicator() {
    return {
        template,
        bindings: {
            portfolio: "<"
        },
        controllerAs: "ctrl",
        controller: DemoAccountIndicatorComponentController
    };
}

export class DemoAccountIndicatorComponentController implements IOnChanges {

    public portfolio?: PortfolioSummary;

    /** @ngInject */
    public constructor(private $element: IRootElementService, private currentUserService: CurrentUserService) {
        this.hide();
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.portfolio != null) {
            if (this.portfolio == null || !this.isSimulated(this.portfolio)) {
                this.hide();
            } else {
                this.show();
            }
        }
    }

    private isSimulated(portfolio: PortfolioSummary): boolean {
        const isSimulatedPortfolio = [PortfolioType.LINKED, PortfolioType.SIMULATED, PortfolioType.SCRATCH].includes(portfolio.portfolioType);
        return isSimulatedPortfolio && !this.currentUserService.isGame();
    }

    private hide() {
        this.$element.css("display", "none");
    }

    private show() {
        this.$element.css("display", "inline-block");
    }
}
